/* eslint-disable no-async-promise-executor */
import api from '~/services/api'
import API_URLS from '~/core/api-urls'
import { NOTIFICATIONS } from '~/core/constants'
import notificationService from '~/services/notifications'
import authWindow from '~/services/auth-window'
import { logInfo } from '~/core/logger'

const checkLoginStatus = async () => {
  const response = await api.get(API_URLS.SALESFORCE.STATUS)

  if (api.isErrorResponse(response)) {
    return false
  }

  return response.isAuthenticated
}

const fetchLoginUrl = () => api.get(API_URLS.SALESFORCE.LOGIN_URL)

const login = ({ loginUrl }) =>
  new Promise(async (resolve, reject) => {
    logInfo({ __filename }, 'Logging in')

    const clearHandlers = () => {
      notificationService.off(NOTIFICATIONS.SALESFORCE_SYNC_OK, resolvePromise)
      notificationService.off(NOTIFICATIONS.SALESFORCE_SYNC_DENIED, rejectPromise)
    }

    const resolvePromise = () => {
      clearHandlers()
      resolve()
    }

    const rejectPromise = () => {
      clearHandlers()
      reject(new Error('failed syncing salesforce'))
    }

    notificationService.on(NOTIFICATIONS.SALESFORCE_SYNC_OK, resolvePromise)
    notificationService.on(NOTIFICATIONS.SALESFORCE_SYNC_DENIED, rejectPromise)

    authWindow.open({
      errorNotification: NOTIFICATIONS.SALESFORCE_SYNC_DENIED,
      statusUrl: API_URLS.SALESFORCE.STATUS,
      successNotification: NOTIFICATIONS.SALESFORCE_SYNC_OK,
      windowUrl: loginUrl
    })
  })

const logout = () => {
  logInfo({ __filename }, 'Logging out')

  return api.get(API_URLS.SALESFORCE.LOGOUT)
}

const fetchRecords = ({ searchText }) => {
  logInfo({ __filename }, 'Searching salesforce records')

  return api.get(API_URLS.SALESFORCE.RECORDS({ searchText }))
}

const fetchRecentRecords = () => {
  logInfo({ __filename }, 'Fetching recent salesforce records')

  return api.get(API_URLS.SALESFORCE.RECENTS)
}

const fetchSessionRecords = ({ sessionId }) => {
  logInfo({ __filename }, 'Fetching session salesforce records')

  return api.get(API_URLS.SALESFORCE.SESSION_RECORDS({ sessionId }))
}

const fetchRecordDetails = ({ recordId, type }) => {
  logInfo({ __filename }, 'Fetching salesforce record details')

  return api.get(API_URLS.SALESFORCE.RECORD_DETAILS({ recordId, type }))
}

const updateSessionWithRecord = ({ notes, sessionId, recordId, recordType }) => {
  logInfo({ __filename }, 'Updating session with salesforce record')

  return api.put(API_URLS.SALESFORCE.UPDATE_SESSION({ sessionId, recordId }), {
    id: recordId,
    notes,
    type: recordType
  })
}

const deleteRecordFromSession = ({ sessionId, recordId, recordType }) => {
  logInfo({ __filename }, 'Deleting salesforce record from session')

  return api.del(API_URLS.SALESFORCE.UPDATE_SESSION({ sessionId, recordId }), {
    id: recordId,
    type: recordType
  })
}

const fetchUserInfo = () => api.get(API_URLS.SALESFORCE.USER_INFO)

export default {
  checkLoginStatus,
  deleteRecordFromSession,
  fetchLoginUrl,
  fetchRecentRecords,
  fetchRecordDetails,
  fetchRecords,
  fetchSessionRecords,
  fetchUserInfo,
  login,
  logout,
  updateSessionWithRecord
}
